import React from 'react';
import { createPortal } from 'react-dom';
import { MAX_Z_INDEX } from '@wix/thunderbolt-commons/dist/zIndex';
const PARSED_MAX_Z_INDEX = parseInt(MAX_Z_INDEX, 10);
export function BlockingLayer({ onClick: externalOnClick, targetId, }) {
    const [rendered, setRendered] = React.useState(false);
    const componentRootRef = React.useRef(null);
    React.useEffect(() => {
        // render the blocking layer only after the
        // viewer component has been rendered
        setRendered(true);
        componentRootRef.current = document.getElementById(targetId);
    }, [targetId]);
    const onClick = ev => {
        ev.stopPropagation();
        externalOnClick?.(ev);
    };
    return rendered && componentRootRef.current
        ? createPortal(React.createElement("div", { onClick: onClick, style: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: PARSED_MAX_Z_INDEX,
                ...(externalOnClick && { cursor: 'pointer' }),
            } }), componentRootRef.current)
        : null;
}
//# sourceMappingURL=BlockingLayer.js.map